import { useMemo } from 'react';
import { Row, Checkbox, ErrorMessage } from '@gv/triage-components';
import {
  useField,
  FieldMetaProps,
  FieldInputProps,
  FieldHelperProps,
} from 'formik';

import { useDetailsQuery } from 'store/api/hospitals';
import { CallOutcomeOptions, CallOutcomeOptionsForRogueValley } from 'types';

import * as Styles from './styles';

export const selects = (
  formikField: [
    FieldInputProps<string[]>,
    FieldMetaProps<string[]>,
    FieldHelperProps<string[]>,
  ],
  options: Readonly<string[]>,
  optionsElements?: Record<string, JSX.Element>
) => {
  const [field, fieldMeta, fieldHelpers] = formikField;
  const selected = field.value ?? [];
  return (
    <div>
      <Row>
        {options.map((option, idx) => (
          <Styles.Col col={6} key={`${field.name}_${option}_${idx}`}>
            <Checkbox
              label={option}
              id={`${field.name}_${option}`}
              checked={selected.includes(option)}
              onChange={async () => {
                const newValue = [...selected];
                const index = newValue.indexOf(option);
                if (index >= 0) {
                  newValue.splice(index, 1);
                } else {
                  newValue.push(option);
                }
                await fieldHelpers.setValue(newValue);
                fieldHelpers.setTouched(true);
              }}
            />

            {selected.includes(option) && optionsElements?.[option]}
          </Styles.Col>
        ))}
      </Row>
      {fieldMeta.touched && fieldMeta.error && (
        <ErrorMessage>{fieldMeta.error}</ErrorMessage>
      )}
    </div>
  );
};

export const Administrative = ({
  name,
  hospitalId,
}: {
  name: string;
  hospitalId?: string;
}) => {
  const administrative = useField(name);
  const hospitalQuery = useDetailsQuery(String(hospitalId), {
    skip: !hospitalId,
  });

  const administrativeItems = useMemo(() => {
    const adminOutcome =
      hospitalQuery?.data?.hospital_calloutcome?.call_outcome?.find(
        (o) => o.outcome === 'administrative'
      );

    return adminOutcome?.subCallOutcome ?? [];
  }, [hospitalQuery?.data?.hospital_calloutcome?.call_outcome]);

  return selects(
    administrative,
    administrativeItems?.length > 0
      ? administrativeItems
      : hospitalId &&
          String(hospitalId) !== process.env.REACT_APP_SHOW_URGENT_CARE
        ? CallOutcomeOptions
        : CallOutcomeOptionsForRogueValley
  );
};
